import React, { useEffect, useState } from "react";
import api from "../api/axios";

function DebtorAllocation() {
    const token = localStorage.getItem("accessToken");
    const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

    const currentDate = new Date();
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [filters, setFilters] = useState({
        entry_type: "Monthly-Auto-Journal",
        year: currentDate.getFullYear(),
        month: currentDate.getMonth() + 1,
    });
    const years = [
        currentDate.getFullYear(),
        currentDate.getFullYear() - 1,
        currentDate.getFullYear() - 2,
    ];
    const months = [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" }
    ];

    const loadData = async () => {
        setLoading(true);
        try {
            const response = await api.get(
                "/debtor-allocation",
                {
                    params: {
                        branch_id,
                        entry_type: filters.entry_type,
                        year: filters.year,
                        month: filters.month,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const data = response.data.data || [];
            data.forEach((row) => {
                row.selected_credit = row.credits.length
                    ? row.credits[0].id
                    : null;
                row.credit_allocate = row.credits.length
                    ? row.credits[0].allocated
                    : 0;
                row.debit_allocate = 0; //row.debit_total;

                row.debits = row.debits.map(d => ({
                    ...d,
                    checked: false,
                    allocated: Number(d.amount)
                }));
            });
            setRows(data);
        }
        catch (err) {
            console.error(err);
            alert("Unable to load data.");
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [
        filters.entry_type,
        filters.year,
        filters.month
    ]);

    const handleFilter = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    const handleDebitAllocation = (rowIndex, value) => {

        let data = [...rows];
        value = Number(value);

        if (value < 0) value = 0;

        if (value > Number(data[rowIndex].debit_total)) {
            value = Number(data[rowIndex].debit_total);
        }
        data[rowIndex].debit_allocate = value;
        setRows(data);
    };

    const handleCreditAllocation = (rowIndex, value) => {
        let data = [...rows];
        const row = data[rowIndex];
        const credit = row.credits.find(
            c => c.id == row.selected_credit
        );
        value = Number(value);

        if (value < 0) value = 0;

        if (credit && value > Number(credit.amount)) {
            value = Number(credit.amount);
        }
        row.credit_allocate = value;
        setRows(data);
    };

    const handleCreditVoucher = (rowIndex, voucherId) => {
        let data = [...rows];
        const row = data[rowIndex];
        row.selected_credit = Number(voucherId);
        const credit = row.credits.find(
            c => c.id == voucherId
        );

        row.credit_allocate = credit
            ? Number(credit.amount)
            : 0;

        setRows(data);
    };

    const handleDebitCheck = (rowIndex, debitIndex) => {
        let data = [...rows];
        let debit = data[rowIndex].debits[debitIndex];
        debit.checked = !debit.checked;
        if (debit.checked) {
            debit.allocated = Number(debit.amount);
        } else {
            debit.allocated = 0;
        }
        let total = data[rowIndex].debits.reduce((sum, d) => {
            return sum + (d.checked ? Number(d.allocated) : 0);
        }, 0);
        data[rowIndex].debit_allocate = total;
        setRows(data);
    };

    const handleDebitEntryAllocation = (rowIndex, debitIndex, value) => {
        let data = [...rows];
        let debit = data[rowIndex].debits[debitIndex];
        value = Number(value);
        if (isNaN(value)) value = 0;
        if (value < 0) value = 0;
        if (value > Number(debit.amount)) {
            value = Number(debit.amount);
        }
        debit.allocated = value;
        let total = data[rowIndex].debits.reduce((sum, d) => {
            return sum + (d.checked ? Number(d.allocated) : 0);
        }, 0);
        data[rowIndex].debit_allocate = total;
        setRows(data);
    };

    const handleSelectAllDebits = () => {
        let data = [...rows];
        const checkAll = !data.every(row =>
            row.debits.every(d => d.checked)
        );

        data.forEach(row => {
            row.debits.forEach(d => {
                d.checked = checkAll;
                d.allocated = checkAll
                    ? Number(d.actual_amount)
                    : 0;
            });

            row.debit_allocate = row.debits
                .filter(d => d.checked)
                .reduce((sum, d) => sum + Number(d.allocated), 0);

            /* if (row.credit_allocate > row.debit_allocate) {
                row.credit_allocate = row.debit_allocate;
            } */

        });

        setRows(data);

    };

    const validateAllocation = () => {
        let atleastOneSelectedFromAll = 0;
        for (let row of rows) {
            const selected = row.debits.filter(d => d.checked && Number(d.allocated) > 0);
            if (selected.length > 0) {
                atleastOneSelectedFromAll++;
                if (Number(row.credit_allocate).toFixed(2) !== Number(row.debit_allocate).toFixed(2)) {
                    alert(row.client_name + "\nAllocated receipt must be equal to debit.");
                    return false;
                }

                for (const debit of selected) {
                    if (Number(debit.allocated) > Number(debit.actual_amount)) {
                        alert(row.client_name + "\nAllocation exceeds debit amount.");
                        return false;
                    }
                }
            }
            /*  if (row.debit_allocate <= 0) {
                 alert(row.client_name + "\nPlease enter allocation.");
                 return false;
             }  */
        }

        if (atleastOneSelectedFromAll === 0) {
            alert("Please select at least one debit entry.");
            return false;
        }

        return true;
    };

    const submitAllocation = async () => {
        if (!validateAllocation()) return;
        if (!window.confirm("Save allocation?")) return;

        const payload = rows.map(row => ({
            ledger_id: row.ledger_id,
            client_id: row.client_id,
            credit_id: row.selected_credit,
            debit_allocate: Number(row.debit_allocate),
            credit_allocate: Number(row.credit_allocate),
            debits: row.debits
                .filter(d => d.checked && Number(d.allocated) > 0)
                .map(d => ({
                    id: d.id,
                    amount: Number(d.actual_amount),
                    allocated: Number(d.allocated)
                }))
        }));
        try {
            setLoading(true);
            const response = await api.post(
                "/debtor-allocation/save",
                {
                    branch_id: branch_id,
                    entry_type: filters.entry_type,
                    year: filters.year,
                    month: filters.month,
                    allocations: payload
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            alert(response.data.message);
            loadData();
        } catch (err) {
            console.error(err);
            alert("Unable to save allocation.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-flex justify-content-between">
                        <h4>
                            Voucher Allocation
                        </h4>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <div className="row col-8">
                        <div className={filters.entry_type === "Other-Invoice" ? "col-md-6" : "col-md-4"}>
                            <label className="fw-bold">
                                Entry Type
                            </label>
                            <select
                                className="form-select"
                                name="entry_type"
                                value={filters.entry_type}
                                onChange={handleFilter}
                            >
                                <option value="Monthly-Auto-Journal">
                                    Monthly Auto Journal
                                </option>
                                <option value="Monthly-Invoice">
                                    Monthly Invoice
                                </option>
                                <option value="Other-Invoice">
                                    Other Invoice
                                </option>
                            </select>
                        </div>
                        <div className={filters.entry_type === "Other-Invoice" ? "col-md-6" : "col-md-4"}>
                            <label className="fw-bold">
                                Year
                            </label>
                            <select
                                className="form-select"
                                name="year"
                                value={filters.year}
                                onChange={handleFilter}
                            >
                                {
                                    years.map((y) => (
                                        <option
                                            key={y}
                                            value={y}
                                        >
                                            {y}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                        {
                            filters.entry_type !== "Other-Invoice" &&
                            <div className="col-md-4">
                                <label className="fw-bold">
                                    Month
                                </label>
                                <select
                                    className="form-select"
                                    name="month"
                                    value={filters.month}
                                    onChange={handleFilter}
                                >
                                    {
                                        months.map((m) => (
                                            <option
                                                key={m.id}
                                                value={m.id}
                                            >
                                                {m.name}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        }
                    </div>
                </div>
                <div className="card-body">
                    {
                        loading ?
                            <div className="text-center">
                                Loading...
                            </div>
                            :
                            <div className="table-responsive ledger-scroll">
                                <table className="table table-bordered align-middle ledger-table">
                                    <thead className="table-light sticky-top">
                                        <tr>
                                            <th width="18%">
                                                Tenant
                                            </th>
                                            <th width="20%">
                                                <div className="d-flex align-items-center">
                                                    <span>Outstandings </span>
                                                    <div className="form-check mb-0 ms-2">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input-custom"
                                                            checked={
                                                                rows.length > 0 &&
                                                                rows.every(row =>
                                                                    row.debits.every(d => d.checked)
                                                                )
                                                            }
                                                            onChange={handleSelectAllDebits}
                                                        />
                                                        <label className="form-check-label small ms-1">
                                                            All
                                                        </label>
                                                    </div>
                                                </div>
                                            </th>
                                            <th>
                                                Remains
                                            </th>
                                            <th className="text-end">
                                                Allocate
                                            </th>
                                            <th width="18%">
                                                Receipt
                                            </th>
                                            <th>
                                                Remains
                                            </th>
                                            <th className="text-end">
                                                Allocate
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            rows.length > 0 ?
                                                rows.map((row, index) => {
                                                    const selectedCredit =
                                                        row.credits.find(c => c.id === row.selected_credit);
                                                    return (
                                                        <tr key={row.ledger_id}>
                                                            {/* Tenant */}
                                                            <td>
                                                                <div className="fw-bold">
                                                                    {row.client_name}
                                                                </div>
                                                                <small className="text-info fs-5">
                                                                    Office: {row.office_no}
                                                                </small>
                                                            </td>
                                                            {/* Debit Entries */}
                                                            <td>
                                                                {
                                                                    row.debits.map((d, debitIndex) => (


                                                                        <div
                                                                            key={d.id}
                                                                            className="form-check mb-1"
                                                                        >

                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input-custom"
                                                                                checked={d.checked}
                                                                                onChange={() =>
                                                                                    handleDebitCheck(index, debitIndex)
                                                                                }
                                                                            />

                                                                            <label
                                                                                className="form-check-label ms-1"
                                                                            >
                                                                                {d.voucher_no}
                                                                            </label>
                                                                            <div className="text-info fs-5">
                                                                                {Number(d.actual_amount).toFixed(2)}
                                                                            </div>
                                                                            {
                                                                                d.checked &&
                                                                                <input
                                                                                    type="number"
                                                                                    className={
                                                                                        Number(d.allocated) < Number(d.actual_amount)
                                                                                            ? "form-control form-control-sm mt-1 text-end border-warning"
                                                                                            : "form-control form-control-sm mt-1 text-end border-info"
                                                                                    }
                                                                                    value={Number(d.allocated).toFixed(2)}
                                                                                    min="0"
                                                                                    max={d.actual_amount}
                                                                                    onChange={(e) =>
                                                                                        handleDebitEntryAllocation(
                                                                                            index,
                                                                                            debitIndex,
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                />
                                                                            }
                                                                        </div>
                                                                    ))
                                                                }
                                                                {/* <small className="text-primary">
                                                                    {row.debits.length} Entries
                                                                </small> */}
                                                            </td>
                                                            {/* Debit Total */}
                                                            <td className="text-end fw-bold">
                                                                {Number(row.debit_total).toFixed(2)}
                                                            </td>
                                                            {/* Debit Allocation */}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    readOnly
                                                                    className="form-control form-control-sm fs-5 text-end"
                                                                    value={Number(row.debit_allocate).toFixed(2)}
                                                                    onChange={(e) => handleDebitAllocation(index, e.target.value)}
                                                                />
                                                            </td>
                                                            {/* Credit Voucher */}
                                                            <td>
                                                                {
                                                                    row.credits.length > 0 ?
                                                                        <select
                                                                            className="form-select"
                                                                            value={row.selected_credit}
                                                                            onChange={(e) => handleCreditVoucher(index, e.target.value)}
                                                                        >
                                                                            {
                                                                                row.credits.map((credit) => (
                                                                                    <option
                                                                                        key={credit.id}
                                                                                        value={credit.id}
                                                                                    >
                                                                                        {credit.voucher_no} - {Number(credit.actual_amount).toFixed(2)} ({credit.voucher_date})
                                                                                    </option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                        :
                                                                        <span className="text-danger">
                                                                            No Receipt
                                                                        </span>
                                                                }
                                                            </td>
                                                            {/* Credit Amount */}
                                                            <td className="text-end fw-bold">
                                                                {
                                                                    selectedCredit ?
                                                                        Number(selectedCredit.amount).toFixed(2)
                                                                        :
                                                                        "0.00"
                                                                }
                                                            </td>
                                                            {/* Credit Allocation */}
                                                            <td>
                                                                {
                                                                    selectedCredit ?
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm fs-5 text-end border-info"
                                                                            value={Number(row.credit_allocate).toFixed(2)}
                                                                            onChange={(e) => handleCreditAllocation(index, e.target.value)}
                                                                        />
                                                                        :
                                                                        "-"
                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                :
                                                <tr>
                                                    <td
                                                        colSpan="7"
                                                        className="text-center"
                                                    >
                                                        No Records Found
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>

                                <div className="row mt-3">
                                    <div className="col-md-3">
                                        <div className="card border">
                                            <div className="card-body text-center">
                                                <h6>
                                                    Total Debtors
                                                </h6>
                                                <h3>
                                                    {rows.length}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card border">
                                            <div className="card-body text-center">
                                                <h6>
                                                    Outstanding
                                                </h6>
                                                <h4>
                                                    {
                                                        rows
                                                            .reduce((sum, r) => sum + Number(r.debit_total), 0)
                                                            .toFixed(2)
                                                    }
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card border">
                                            <div className="card-body text-center">
                                                <h6>
                                                    Receipt
                                                </h6>
                                                <h4>
                                                    {
                                                        rows
                                                            .reduce((sum, r) => sum + Number(r.credit_allocate), 0)
                                                            .toFixed(2)
                                                    }
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="card border">
                                            <div className="card-body text-center">
                                                <button
                                                    className="btn btn-success w-100"
                                                    onClick={submitAllocation}
                                                >
                                                    Save Allocation
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div >
            </div >
        </>
    );
}
export default DebtorAllocation;